import { UserAddress } from "../store/slice/userSlice";
import apiClient from "./apiClient";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

export type UserInfo = {
  companyName: string;
  lastName: string;
  updatedAt: number;
  username: string;
  id: string;
  firstName: string;
  email_address: string;
  discountRate: number;
};

export const API_URL =
  process.env.REACT_APP_API_URL || "https://sp-hygiene.com/api";

export const getUser = createAsyncThunk(
  "user/getUser",
  async (token: string, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/users/profile`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const editUser = createAsyncThunk(
  "user/editUser",
  async (
    params: { userInfo: Partial<UserInfo>; token: string },
    { rejectWithValue }
  ) => {
    try {
      const { token, userInfo } = params;
      const response = await apiClient.patch(
        `${API_URL}/users/profile`,
        userInfo,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Profil mis à jour !", {
        className: "toast-success",
      });
      return response.data;
    } catch (error: any) {
      toast.error("Erreur lors de la mise à jour du profil", {
        className: "toast-error",
      });
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

// User addresses

export const getUserAddresses = createAsyncThunk(
  "user/getUserAddresses",
  async (token: string, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/users/addresses`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const addUserAddress = createAsyncThunk(
  "user/addUserAddress",
  async (
    params: { address: UserAddress; token: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiClient.post(
        `${API_URL}/users/addresses`,
        params.address,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${params.token}`,
          },
        }
      );

      toast.success("Votre adresse a bien été ajoutée", {
        className: "toast-success",
      });

      return response.data;
    } catch (error: any) {
      toast.error("Erreur lors de l'ajout d'adresse", {
        className: "toast-error",
      });
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const deleteUserAddress = createAsyncThunk(
  "user/deleteUserAddress",
  async (params: { id: string; token: string }, { rejectWithValue }) => {
    try {
      await apiClient.delete(`${API_URL}/users/addresses/${params.id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${params.token}`,
        },
      });

      toast.success("Votre adresse a bien été supprimé", {
        className: "toast-success",
      });

      return params.id;
    } catch (error: any) {
      toast.error("Erreur lors de la suppression de l'adresse", {
        className: "toast-error",
      });
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const editUserAddress = createAsyncThunk(
  "user/editUserAddress",
  async (
    params: { userAddress: Partial<UserInfo>; token: string; id: string },
    { rejectWithValue }
  ) => {
    try {
      const { token, userAddress, id } = params;
      const response = await apiClient.patch(
        `${API_URL}/users/addresses/${id}`,
        userAddress,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("L'adresse a bien été mise à jour !", {
        className: "toast-success",
      });
      return response.data;
    } catch (error: any) {
      toast.error("Erreur lors de la mise à jour de l'adresse", {
        className: "toast-error",
      });
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

// User orders

export const getUserOrders = createAsyncThunk(
  "user/getUserOrders",
  async (token: string, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/orders`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);

export const getUserOrder = createAsyncThunk(
  "user/getUserOrder",
  async (params: { token: string; id: string }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`${API_URL}/orders/${params.id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${params.token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Erreur inconnue");
    }
  }
);
